import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '@core/providers/http/api.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ProfissionaisRepresentacaoEmpresaService {
  private readonly path = 'profissionais';
  public params = new HttpParams();

  constructor(private apiService: ApiService) {}

  // List all RepresentacaoEmpresa
  list(params?: any): Observable<any> {
    return this.apiService
      .get<{ data: any[] }>(
        `${this.path}/getAllRepresentacaoEmpresa`,
        params
          ? new HttpParams({
              fromObject: params,
            })
          : this.params,
        true
      )
      .pipe(map((response) => response));
  }

  // Get RepresentacaoEmpresa by ID
  public show(id: string): Observable<any> {
    return this.apiService
      .get<{ object: any }>(
        `${this.path}/getRepresentacaoEmpresaById/${id}`,
        this.params,
        true
      )
      .pipe(map((response) => response.object));
  }

  // Create new RepresentacaoEmpresa
  public store(data: any): Observable<any> {
    return this.apiService
      .post<{ object: any }>(
        `${this.path}/AddRepresentacaoEmpresa`,
        data,
        {},
        true
      )
      .pipe(map((response) => response.object));
  }

  // Create multiple RepresentacaoEmpresa
  public storeRange(data: any[]): Observable<any> {
    return this.apiService
      .post<any>(`${this.path}/AddRepresentacaoEmpresaRange`, data, {}, true)
      .pipe(map((response) => response));
  }

  // Update existing RepresentacaoEmpresa
  public update(data: any): Observable<any> {
    return this.apiService.put<{ object: any }>(
      `${this.path}/UpdateRepresentacaoEmpresa`,
      data,
      this.params,
      true
    );
  }

  // Delete existing RepresentacaoEmpresa
  public delete(id: string): Observable<any> {
    return this.apiService.delete(
      `${this.path}/DeleteRepresentacaoEmpresaById/${id}`,
      this.params,
      true
    );
  }

  // Get photo of RepresentacaoEmpresa
  public getPhoto(id: string): Observable<any> {
    return this.apiService.get(
      `${this.path}/getPhotoRepresentacaoEmpresa/${id}`,
      this.params,
      true,
      "blob"
    );
  }
}
